import { Airror } from '@air/errors';

/**
 * @deprecated - Use the one from `@air/utils-error` instead.
 */
export function isAirrorInstance(result: any): result is Airror<any, any> {
  return result instanceof Airror;
}
